import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { View } from 'react-native';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';

import { UploadScreenChildProps } from '../UploadScreen.types';

export type ErrorFatalComponentProps = UploadScreenChildProps;

export const ErrorFatalComponent = ({ title, description, style }: ErrorFatalComponentProps) => {

  return (
    <View style={style.uploadContent}>
      <View style={{ width: 56, height: 56 }}>
        <Illustration name={ILLUSTRATION_NAMES.Error} />
      </View>
      <View style={style.textWrapper}>
        <TextLato style={style.title}>{title}</TextLato>
        <TextLato style={style.text}>{description}</TextLato>
      </View>
    </View>
  );
};

